module.exports = __webpack_public_path__ + "img/lg_ring_r_e_null_0@2x.cc12ef8e.png";